import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'

import { CommentaireC, CommentForm } from './CommentCreate'
import { useAppDispatch, RootState, AppDispatch } from '../../redux/store'
import {
  addComment,
  deleteComment,
  getCommentsByActionId,
} from '../../redux/comments/commentActions'
import { Comment } from '../../types/commentTypes'
import { hasRole } from '../../utils/checkRole'
import { UserRole } from '../../types/keycloak'
import { DetailEmptyState } from '../../components/common/detail'
import '../../components/common/detail/detail.css'

interface CommentSectionProps {
  idaction: string
}

const CommentSection: React.FC<CommentSectionProps> = ({ idaction }) => {
  const { t } = useTranslation()
  const dispatch: AppDispatch = useAppDispatch()
  const roles = useSelector((state: any) => state.auth.roles)
  const commentairesList = useSelector(
    (state: RootState) => state.comment.comments
  )

  useEffect(() => {
    if (idaction) dispatch(getCommentsByActionId(idaction))
  }, [dispatch, idaction])

  const handleAddComment = async (Commentaire: string) => {
    await dispatch(
      addComment({
        Commentaire,
        ActionId: idaction,
      })
    )
  }

  const handleDeleteComment = async (_id: string) => {
    await dispatch(deleteComment(_id))
  }

  const commentairesArray = commentairesList
    ? Object.entries(commentairesList)
        .filter(([key]) => !isNaN(Number(key)))
        .map(([, value]) => value as Comment)
        .sort(
          (a, b) =>
            new Date(b.CreationDate ?? 0).getTime() -
            new Date(a.CreationDate ?? 0).getTime()
        )
    : []

  const canComment = !hasRole(roles, UserRole.OTHERS)

  return (
    <div className="detail-comments">
      {canComment ? <CommentForm onSubmit={handleAddComment} /> : null}

      <div className="detail-comment-feed">
        {commentairesArray.length > 0 ? (
          <>
            <p className="detail-comment-feed-meta">
              {commentairesArray.length}{' '}
              {t('taskDetailsPage.activitiesAccordion.tabs.comment', {
                defaultValue: 'Comments',
              })}
            </p>
            {commentairesArray.map((comment) => (
              <CommentaireC
                key={comment._id}
                comment={comment}
                onDelete={handleDeleteComment}
              />
            ))}
          </>
        ) : (
          <DetailEmptyState
            title={t('missionDetailsPage.empty.title', {
              defaultValue: 'Nothing here yet',
            })}
            message={t('taskDetailsPage.empty.comments', {
              defaultValue: 'No comments on this task yet. Start the conversation.',
            })}
          />
        )}
      </div>
    </div>
  )
}

export default CommentSection
